export default "__VITE_ASSET__6df17fbc__"